import { render, staticRenderFns } from "./AuthBan.vue?vue&type=template&id=0a5cf1be&scoped=true&"
import script from "./AuthBan.vue?vue&type=script&lang=js&"
export * from "./AuthBan.vue?vue&type=script&lang=js&"
import style0 from "./AuthBan.vue?vue&type=style&index=0&id=0a5cf1be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5cf1be",
  null
  
)

export default component.exports